const INITIAL_STATE = {
    email: '', user: '', password: '', text: ''
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'EMAIL_CHANGE_LOGIN':
            return { ...state, email: action.payload };
        case 'PASSWORD_CHANGE_LOGIN':
            return { ...state, password: action.payload };
        case 'LOGIN':
            return { ...state };
        case 'LOGIN_SUCCESS':
            return { ...state, user: action.payload, email: '', password: '' };
        case 'LOGIN_FAIL':
            return { ...state, email: '', password: '', text: 'Login Error' };
        case 'LOGGEDIN_CHECK':
            return { ...state };
        case 'LOGGEDIN':
            return { ...state, user: action.payload };
        case 'NOT_LOGGEDIN':
            return { ...state };
        case 'LOGOUT':
            return { ...state, email: '', password: '' };
        case 'LOGOUT_SUCCESS':
            return { ...state, email: '', password: '' };
        case 'LOGOUT_FAILURE':
            return { ...state, email: '', password: '' };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Auth/AuthReducer.js